// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"styles_horizontal__7yC8_","vertical":"styles_vertical__lz9EH"};